import { useState, useEffect, useRef } from "react";
import { getFirestore, collection, getDocs, getDoc, doc, query, deleteDoc, updateDoc, deleteField, where } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import DataTable from "examples/Tables/DataTable";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import ActionCell from "./components/actionCell";
import PropTypes from 'prop-types';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppBar from "@mui/material/AppBar";
import SoftInput from "components/SoftInput";
import SoftBadge from "components/SoftBadge";
import SoftButton from "components/SoftButton";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import { ClockLoader } from "react-spinners";
import SpeechToTextSummaries from "layouts/pages/projects/recording/speechRecoSums.js";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { ScaleLoader } from "react-spinners";
import SpeechToText from "layouts/pages/projects/recording/speechRecognition.js";
import ReportProblemModal from "examples/problemReporting/reportProblem";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import Checkbox from "@mui/material/Checkbox";
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SoftSnackbar from "components/SoftSnackbar";
import Swal from "sweetalert2";
import NotLoggedIn from "examples/noUser/notLoggedIn";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};



function VisitDetails({ visit, selectedPatient, currentUserSubscription }) {

  const [currentTab, setCurrentTab] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSummaries, setFilteredSummaries] = useState([]);
  const [editMode, setEditMode] = useState({});
  const [editedText, setEditedText] = useState({});
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const [showSaveError, setShowSaveError] = useState(false);
  const [editModeTemplate, setEditModeTemplate] = useState({});
  const [editedTextTemplate, setEditedTextTemplate] = useState({});
  const [showSaveSuccessTemplate, setShowSaveSuccessTemplate] = useState(false);
  const [showSaveErrorTemplate, setShowSaveErrorTemplate] = useState(false);
  const [visitState, setVisitState] = useState(visit);
  const [copyAllTemplate, setCopyAllTemplate] = useState(false);
  const [copyTemplateSummary, setCopyTemplateSummary] = useState(false);
  const [copyAllSummary, setCopyAllSummary] = useState(false);
  const [copySelectedSummary, setCopySelectedSummary] = useState(false);
  const [copySelectedTemplateSums, setCopySelectedTemplateSums] = useState(false);
  const [copySummary, setCopySummary] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState({});
  const [menuAnchorElTemplate, setMenuAnchorElTemplate] = useState({});
  const [isRegenerating, setIsRegenerating] = useState({});
  const [isRegeneratingTemplate, setIsRegeneratingTemplate] = useState({});
  const [promptsData, setPromptsData] = useState({});
  const [templates, setTemplates] = useState([])
  const [userId, setUserId] = useState(null);
  const [openTalkToSummaries, setOpenTalkToSummaries] = useState({});
  const [openTalkToNotes, setOpenTalkToNotes] = useState({});
  const [refineSummariesNotes, setRefineSummariesNotes] = useState({});
  const [refineTemplateNotes, setRefineTemplateNotes] = useState({});
  const [isRecordingToSummaries, setIsRecordingToSummaries] = useState({}); 
  const [isRecordingToTemplates, setIsRecordingToTemplates] = useState({}); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailSubjects, setEmailSubjects] = useState({});
  const [emailContentEdits, setEmailContentEdits] = useState({});
  const [emailSenderNames, setEmailSenderNames] = useState({});
  const [emailSenderEmails, setEmailSenderEmails] = useState({});
  const [patientEmail, setPatientEmail] = useState("");
  const [agreementEmail, setAgreementEmail] = useState(false);
  const [senderName, setSenderName] = useState('');
  const [senderEmail, setSenderEmail] = useState('');
  const [providerName, setProviderName] = useState('');
  const [selectedSummaries, setSelectedSummaries] = useState({});
  const [selectedTemplateSummaries, setSelectedTemplateSummaries] = useState({});
  const [templateSummariesOrder, setTemplateSummariesOrder] = useState([]);
  const [currentResultIndex, setCurrentResultIndex] = useState(0);
  const [resultsCount, setResultsCount] = useState(0);
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const [templateCurrentResultIndex, setTemplateCurrentResultIndex] = useState(0);
  const [templateResultsCount, setTemplateResultsCount] = useState(0);

  const countOccurrences = (text, term) => {
    const regex = new RegExp(term, "gi"); 
    return (text.match(regex) || []).length;
  };

  useEffect(() => {
    const updateCounts = () => {
      const regex = new RegExp(`(${debouncedSearchTerm})`, 'gi');
  
      if (currentTab === 0) {
        const count = filteredSummaries.reduce((acc, [_, summaryDetails]) => {
          return acc + (summaryDetails.response.match(regex) || []).length;
        }, 0);
        setResultsCount(count);
      } else if (currentTab === 1) {
        const count = Object.entries(visitState.data.templates || {}).reduce((acc, [templateName, templateData]) => {
          return acc + templateData.reduce((innerAcc, summary) => {
            return innerAcc + (summary.data.response.match(regex) || []).length;
          }, 0);
        }, 0);
        setTemplateResultsCount(count);
      } else {
        setResultsCount(0);
        setTemplateResultsCount(0);
      }
    };
  
    if (debouncedSearchTerm) {
      updateCounts();
    } else {
      setResultsCount(0);
      setTemplateResultsCount(0);
    }
  }, [debouncedSearchTerm, filteredSummaries, visitState.data.templates, currentTab]);

  useEffect(() => {
    const fetchTemplateSummaryOrder = async () => {
        // Ensure we have a valid userId and there's a selected template for the visit
        if (!userId || !visitState || !visitState.data.templates) return;
    
        const db = getFirestore();

        // Example of how you might determine the current template's name
        // This is just a placeholder; you'll need to replace it with your actual logic
        const currentTemplateName = Object.keys(visitState.data.templates)[0];

        // Ensure there's a current template name available
        if (!currentTemplateName) return;

        const templateRef = doc(db, `users/${userId}/templateprompts`, currentTemplateName);
    
        try {
            const templateDoc = await getDoc(templateRef);
            if (templateDoc.exists()) {
                const templateData = templateDoc.data();
                // Check if the order exists and set it, otherwise use a default or keep it empty
                const order = templateData.summariesOrder ? templateData.summariesOrder : [];
                setTemplateSummariesOrder(order);
            } else {
                console.log("No such template!");
                setTemplateSummariesOrder([]); // Reset or keep previous order
            }
        } catch (error) {
            console.error("Error fetching template summary order:", error);
            setTemplateSummariesOrder([]); // Reset or keep previous order in case of error
        }
    };

    fetchTemplateSummaryOrder();
  }, [userId, visitState]); 




  useEffect(() => {
    setSelectedSummaries({});
    setSelectedTemplateSummaries({});
  }, [visitState.id]); 

  const toggleTemplateSummarySelection = (templateId, summaryId) => {
    setSelectedTemplateSummaries(prev => ({
      ...prev,
      [templateId]: {
        ...prev[templateId],
        [summaryId]: !prev[templateId]?.[summaryId],
      },
    }));
  };

  const copySelectedTemplateSummaries = async () => {
    const visitDate = new Date(visitState.data.timestamp);
    const formattedDate = visitDate.toLocaleDateString("en-US", {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    });
    const formattedTime = visitDate.toLocaleTimeString("en-US", {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    const headerText = `Note Title: ${visitState.id}\nProvider: ${providerName}\nDate: ${formattedDate} ${formattedTime}\n\n`;
        
    let allSummariesText = "";
    
    Object.entries(selectedTemplateSummaries).forEach(([templateId, summaries]) => {
      const templateName = visitState.data.templates[templateId]?.name || templateId; // Adjust based on how template names are stored
      Object.entries(summaries).forEach(([summaryId, isSelected]) => {
        if (isSelected) {
          const summaryDetails = visitState.data.templates[templateId].find(summary => summary.id === summaryId);
          if (summaryDetails) {
            allSummariesText += `====\n${summaryId}\n====\n\n${summaryDetails.data.response}\n\n`;
          }
        }
      });
    });
    
    const combinedText = headerText + allSummariesText;
    
    try {
      await navigator.clipboard.writeText(combinedText);
      console.log("Selected template summaries copied");
      setCopySelectedTemplateSums(true); 
  
      setTimeout(() => {
        setCopySelectedTemplateSums(false); 
      }, 2000);
    } catch (err) {
      console.error("Failed to copy selected template summaries: ", err);
    }
  };
  
  


  const toggleSummarySelection = (id) => {
    setSelectedSummaries(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const copySelectedSummaries = async () => {
    const visitDate = new Date(visitState.data.timestamp);
    const formattedDate = visitDate.toLocaleDateString("en-US", {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    });
    const formattedTime = visitDate.toLocaleTimeString("en-US", {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    const headerText = `Note Title: ${visitState.id}\nProvider: ${providerName}\nDate: ${formattedDate} ${formattedTime}\n\n`;  
    // Assuming summaries is an object where keys are summary IDs and values are the summary details
    const selectedSummariesText = Object.entries(selectedSummaries)
      .filter(([id, isSelected]) => isSelected)
      .map(([id]) => {
        const summaryDetails = visitState.data.summaries[id]; // Adjust based on your data structure
        return `====\n${id}\n====\n\n${summaryDetails.response}`;
      })
      .join("\n\n");
  
    const combinedText = headerText + selectedSummariesText;
  
    try {
      await navigator.clipboard.writeText(combinedText);
      console.log("Selected summaries copied");
      setCopySelectedSummary(true);  
  
      setTimeout(() => {
        setCopySelectedSummary(false); // Consider using a different state variable for better clarity
      }, 2000);
    } catch (err) {
      console.error("Failed to copy selected summaries: ", err);
    }
  };
  

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
        const fetchUserNames = async () => {
            try {
                const db = getFirestore();
                const userDocRef = doc(db, "users", user.uid);
                const userDoc = await getDoc(userDocRef);

                const fullName = `${userDoc.data().firstname} ${userDoc.data().lastname}`;
                console.log(" full name: ", fullName)
                setProviderName(fullName);
            } catch (error) {
                console.log(" could not retrieve user name")
            }   
        };
        fetchUserNames();
    }
    });
    return () => unsubscribe();
  }, []);
  


  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);



  // Handlers for state changes
  const handleEmailSubjectChange = (instructionId, value) => {
    setEmailSubjects({ ...emailSubjects, [instructionId]: value });
  };

  const handleEmailContentEdit = (emailTitle, newContent) => {
    setVisitState(prevState => ({
      ...prevState,
      data: {
        ...prevState.data,
        emails: {
          ...prevState.data.emails,
          [emailTitle]: {
            ...prevState.data.emails[emailTitle],
            response: newContent,
          },
        },
      },
    }));
  };

  const handleEmailSenderNameChange = (instructionId, value) => {
    setEmailSenderNames({ ...emailSenderNames, [instructionId]: value });
  };

  const handleEmailSenderEmailChange = (instructionId, value) => {
    setEmailSenderEmails(prev => ({ ...prev, [instructionId]: value }));
  };

  const handlePatientEmailChange = (e) => {
    setPatientEmail(e.target.value);
  };

  const handleSetAgreement = () => {
    setAgreementEmail(!agreementEmail);
  };

  const handleSendEmail = async (instructionId) => {
    if ((!patientEmail || patientEmail.trim() === '')) {
      Swal.fire({
          icon: 'warning',
          title: 'Missing Patient Email',
          text: 'Please enter the email of the patient.',
          confirmButtonColor: '#344767',
          confirmButtonText: 'OK'
      });
      return; // Stop the function if no patient name is provided or selected
    }
    const emailContent = visitState.data.emails[instructionId].response;
    const emailSubject = emailSubjects[instructionId] || "";
    const sendersName = emailSenderNames[instructionId] || senderName;
    const sendersEmail = emailSenderEmails[instructionId] || senderEmail;

    // Construct the payload
    const payload = {
        subject: emailSubject,
        content: emailContent,
        senderName: sendersName,
        patientEmail: patientEmail,
        senderEmail: sendersEmail
    };

    try {
        const response = await fetch('`${process.env.REACT_APP_API_BASE_URL}/api/ghl/patient-instructions`', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        //setEmailSentSuccess(true);
        //setTimeout(() => setEmailSentSuccess(false), 5000); 
        setAgreementEmail(false);
        showSnackbar("dark", "email" ,"Email is sent to patient!", "Tell patient to see spam folder as well.");
    } catch (error) {
        console.error("Error sending email to the webhook:", error);
        // Handle error, e.g., showing an error message
    }
  };

  const showSnackbar = (color, icon, title, message ) => {
    setSnackbar({ show: true, color, icon, title, message: `${message}`});
  };

  const [snackbar, setSnackbar] = useState({
    show: false,
    message: "",
    title: "",
  });

  const hideSnackbar = () => {
    setSnackbar({ ...snackbar, show: false });
  };


  useEffect(() => {
    const auth = getAuth(); 
    const db = getFirestore();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
            const fetchSenderDetails = async () => {
                const userRef = doc(db, "users", user.uid);
                try {
                    const docSnap = await getDoc(userRef);
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setSenderName(data.senderName || '');
                        setSenderEmail(data.senderEmail || '');
                    } else {
                        console.log("No sender details found");
                    }
                } catch (error) {
                    console.error("Error fetching sender details: ", error);
                }
            };

            fetchSenderDetails();
        }
    });

    // Cleaning up the listener when component unmounts
    return () => unsubscribe();
  }, []); 


  const loadTemplatesFromLocalstorage = () => {
    const templatesDataString = localStorage.getItem("templatesData");
    return templatesDataString ? JSON.parse(templatesDataString) : null;
  }    

  const saveTemplatesToLocalstorage = (templatesData) => {
    const templatesDataString = JSON.stringify(templatesData);
    localStorage.setItem("templatesData", templatesDataString);
  }  

  useEffect(() => {
    const cachedTemplates = loadTemplatesFromLocalstorage();
    if (cachedTemplates) {
        setTemplates(cachedTemplates); 
    }

    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
        if (user) {
            setUserId(user.uid);
            const db = getFirestore();

            // Fetch prompts
            const promptsRef = collection(db, `users/${user.uid}/prompts`);

            try {
                const querySnapshot = await getDocs(promptsRef);
                let promptsData = {};
                querySnapshot.forEach((doc) => {
                    promptsData[doc.id] = doc.data().content; // Assuming 'content' holds the prompt text
                });
                // Update your state or context with fetched prompts
                setPromptsData(promptsData);
                console.log("Fetched prompts from db: ", promptsData)
            } catch (error) {
                console.error("Error fetching prompts:", error);
            }

            // Fetch template prompts
            const templatesRef = collection(db, `users/${user.uid}/templateprompts`)
            
            try {
                const templateSnapshot = await getDocs(templatesRef);
                let templatesData = [];
                console.log(`Fetched ${templateSnapshot.docs.length} templates`);


                for (const doc of templateSnapshot.docs) {
                    console.log(`Template ID: ${doc.id}`, doc.data());
                
                    const summariesSnapshot = await getDocs(collection(db, `users/${user.uid}/templateprompts/${doc.id}/summaries`));
                    let summariesData = [];
                    summariesSnapshot.forEach(summaryDoc => {
                        summariesData.push({
                        id: summaryDoc.id,
                        content: summaryDoc.data().content // Assuming 'content' holds the prompt text
                        });
                        console.log(`Summary ID: ${summaryDoc.id}`, summaryDoc.data());
                    });

                    // Include template details (name, iconName, etc.) and associated prompts
                    templatesData.push({
                        id: doc.id,
                        name: doc.data().name,
                        iconName: doc.data().iconName,
                        description: doc.data().description,
                        associatedPrompts: summariesData // Map summaries to just content if that's all you need
                    });
                }
                saveTemplatesToLocalstorage(templatesData);
                setTemplates(templatesData);
                console.log("templates date: ", templatesData)
            } catch (error) {
                console.error("Error fetching template prompts:", error);
            }

        } else {
            console.log("No user logged in");
        }
    });
  }, []);


  useEffect(() => {
    setVisitState(visit);
    console.log("visits: ", visit)
  }, [visit]); 


  const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm) return text;

    const parts = String(text).split(new RegExp(`(${searchTerm})`, 'gi'));
    return parts.map((part, index) => part.toLowerCase() === searchTerm.toLowerCase()
      ? <span key={index} style={{ backgroundColor: 'lightblue' }}>{part}</span>
      : part);
  };

  const splitTranscriptBySpeakers = (transcriptText) => {
    const speakerRegex = /(Speaker \d+:)/g;
    return transcriptText.split(speakerRegex).slice(1); 
  };
  

  const renderTranscriptWithSpeakers = () => {
    try {
      const transcriptText = visitState.data.transcript;
      const transcriptParts = splitTranscriptBySpeakers(transcriptText);

      return transcriptParts.map((part, index) => {
          const trimmedPart = part.trimStart().trimEnd();
          // Odd indexes are speaker labels, even indexes are the corresponding text
          if (index % 2 === 0) {
              // Speaker label
              return (
                  <SoftBox key={index} display="flex" alignItems="center">
                      <SoftBadge
                          variant="contained"
                          color={getBadgeColor(part)} // Dynamic color based on speaker ID
                          size="md"
                          badgeContent={part}
                          circular
                          container
                          sx={{ pl: 1 }}
                      />
                  </SoftBox>
              );
          } else {
              // Speaker text
              return (
                  <SoftTypography pt={1.5} pb={2} pl={1.7} pr={3} key={index} variant="body2" component="div" sx={{ whiteSpace: 'pre-wrap' }} >
                      {highlightSearchTerm(trimmedPart, searchTerm)}
                  </SoftTypography>
              );
          }
      });
    } catch (error) {
      console.error("Error rendering transcript with speakers:", error);
      return (
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
          <SoftTypography variant="h6" >
            An error occurred while processing the transcript.
          </SoftTypography>
          <SoftTypography onClick={handleOpenModal} variant="button" sx={{ textDecoration: 'underline', cursor: 'pointer', mt:2 }} >
            Report this problem.
          </SoftTypography>
          <ReportProblemModal open={isModalOpen} onClose={handleCloseModal} />
        </SoftBox>
      );
    }
  };

  const getBadgeColor = (speakerLabel) => {
    const match = speakerLabel.match(/\d+/);
    if (!match) {
        console.error('No speaker ID found in label:', speakerLabel);
        return 'error'; // Default color or handling for unexpected labels
    }
    const speakerId = parseInt(match[0], 10);
    switch (speakerId) {
        case 0:
            return 'secondary'; // Example color
        case 1:
            return 'dark'; // Example color
        case 2:
            return 'primary'; // Choose appropriate color
        case 3:
            return 'info'; // Choose appropriate color
        case 4:
            return 'success'; // Choose appropriate color
        case 5:
            return 'warning'; // Choose appropriate color
        default:
            return 'error'; // Fallback color for unexpected IDs
    }
  };
  



  const handleEditClick = (summaryName, summaryDetails) => {
    setEditMode({ ...editMode, [summaryName]: true });
    setEditedText({ ...editedText, [summaryName]: summaryDetails.response }); // Assume summaryDetails.response is accessible, adjust as needed
  };

  const handleCancel = (summaryName) => {
    setEditMode({ ...editMode, [summaryName]: false });
  };

  const handleSaveSummary = async (summaryName) => {
    const db = getFirestore();
    const auth = getAuth();
    const user = auth.currentUser

    if (!user) {
      console.log("No user signed in");
      return;
    }
  
    const visitDocRef = doc(db, `users/${user.uid}/summaries/${selectedPatient}/visits/${visitState.id}`);
    
    try {
      await updateDoc(visitDocRef, {
        [`summaries.${summaryName}.response`]: editedText[summaryName]
      });
      console.log("Summary updated successfully");
      
      // Update local state to reflect changes
      setEditMode({ ...editMode, [summaryName]: false });
      const updatedSummaries = { ...visitState.data.summaries, [summaryName]: { ...visitState.data.summaries[summaryName], response: editedText[summaryName] } };
      visitState.data.summaries = updatedSummaries; // Make sure this does not directly mutate the state
      setFilteredSummaries(Object.entries(sortSummariesWithCustomOrder(updatedSummaries, summariesOrder)));
      setShowSaveSuccess(prevState => ({ ...prevState, [summaryName]: true }));
      setTimeout(() => setShowSaveSuccess(prevState => ({ ...prevState, [summaryName]: false })), 3000);
      setShowSaveError(prevState => ({ ...prevState, [summaryName]: false }));
      
    } catch (error) {
      console.error("Error updating summary:", error);
      setShowSaveError(prevState => ({ ...prevState, [summaryName]: true }));
    }
  };

  const handleCopySummary = async (title, text) => {
    const formattedText = `${title}:\n${text}`;
    try {
      await navigator.clipboard.writeText(formattedText);
      setCopySummary(prev => ({ ...prev, [title]: true }));
      setTimeout(() => {
        setCopySummary(prev => ({ ...prev, [title]: false }));
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const handleCopyAllSummaries = async () => {
    const visitDate = new Date(visitState.data.timestamp);
    const formattedDate = visitDate.toLocaleDateString("en-US", {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    });
    const formattedTime = visitDate.toLocaleTimeString("en-US", {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    const headerText = `Note Title: ${visitState.id}\nProvider: ${providerName}\nDate: ${formattedDate} ${formattedTime}\n\n`;
    const allSummariesText = filteredSummaries.map(([summaryId, summaryDetails]) => 
    `====\n${summaryId}\n====\n\n${summaryDetails.response}`).join("\n\n");

    const combinedText = headerText + allSummariesText
    try {
      await navigator.clipboard.writeText(combinedText);
      setCopyAllSummary(true);

      setTimeout(() => {
          setCopyAllSummary(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy all summaries: ', err);
    }
  };
  
  


  const handleEditTemplate = (templateName, summary) => {
    const uniqueKey = `${templateName}-${summary.id}`;
    setEditModeTemplate({ ...editModeTemplate, [uniqueKey]: true });
    
    setEditedTextTemplate({ ...editedTextTemplate, [summary]: summary.data.response });
  };

  
  const handleCancelTemplate = (templateName, summary) => {
    const uniqueKey = `${templateName}-${summary.id}`;
    setEditModeTemplate({ ...editModeTemplate, [uniqueKey]: false });
    //setEditedTextTemplate({ ...editedTextTemplate, [uniqueKey]: summary.data.response})
  };
  
  const handleSaveTemplate = async (templateId, summary) => {
    const db = getFirestore();
    const user = getAuth().currentUser;
    const uniqueKey = `${templateId}-${summary.id}`;

    const templateDocRef = doc(db, `users/${user.uid}/summaries/${selectedPatient}/visits/${visitState.id}/templates/${templateId}`);
  
    try {
      const updatePath = `templateSummaries.${summary.id}.response`;
      await updateDoc(templateDocRef, {
        [updatePath]: editedTextTemplate[summary] 
      });
      console.log("Template updated successfully");
  
      setEditModeTemplate({ ...editModeTemplate, [uniqueKey]: false });


      const updatedTemplates = { ...visitState.data.templates };
      const templateIndex = updatedTemplates[templateId].findIndex(s => s.id === summary.id);
      if (templateIndex !== -1) {
        updatedTemplates[templateId][templateIndex].data.response = editedTextTemplate[summary];
      }

      // Update the state to reflect the changes
      setVisitState({
        ...visitState,
        data: {
          ...visitState.data,
          templates: updatedTemplates
        }
      });
  

      setShowSaveSuccessTemplate(prevState => ({ ...prevState, [uniqueKey]: true }));
      setTimeout(() => setShowSaveSuccessTemplate(prevState => ({ ...prevState, [uniqueKey]: false })), 3000);
      setShowSaveErrorTemplate(prevState => ({ ...prevState, [uniqueKey]: false }));
    } catch (error) {
      console.error("Error updating template:", error);
      setShowSaveErrorTemplate(prevState => ({ ...prevState, [uniqueKey]: true }));
    }
  };

  const handleCopySummaryTemplate = async (title, text) => {
    const formattedText = `${title}:\n${text}`;
    try {
      await navigator.clipboard.writeText(formattedText);
      setCopyTemplateSummary(prev => ({ ...prev, [title]: true }));

      setTimeout(() => {
        setCopyTemplateSummary(prev => ({ ...prev, [title]: false }));
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const handleCopyAllTemplateSummaries = () => {
    const visitDate = new Date(visitState.data.timestamp);
    const formattedDate = visitDate.toLocaleDateString("en-US", {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    });
    const formattedTime = visitDate.toLocaleTimeString("en-US", {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    let allSummariesText = `Note Title: ${visitState.id}\nProvider: ${providerName}\nDate: ${formattedDate} ${formattedTime}\n\n`;
    Object.entries(visitState.data.templates || {}).forEach(([, templateData]) => {
      templateData.forEach(summary => {
        // Assuming 'summary.id' is the name of the summary and 'summary.data.response' contains the content
        allSummariesText += `====\n${summary.id}\n====\n\n`;
        allSummariesText += `${summary.data.response}\n\n`; // Add the content
      });
    });
  
    // Copy allSummariesText to clipboard
    navigator.clipboard.writeText(allSummariesText).then(() => {
      console.log("Summaries copied to clipboard successfully.");
      setCopyAllTemplate(true);

      setTimeout(() => {
          setCopyAllTemplate(false);
      }, 2000);
    }, (err) => {
      console.error('Could not copy summaries to clipboard: ', err);
      // Optionally, you can update the UI to show an error message
    });
  };
  
  




  useEffect(() => {
    const sortedSummaries = sortSummariesWithCustomOrder(visitState.data.summaries, summariesOrder);

    if (searchTerm === '') {
      setFilteredSummaries(Object.entries(sortedSummaries));
    } else {
      const filtered = Object.entries(sortedSummaries).filter(([summaryName, summaryDetails]) =>
        summaryDetails.response.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSummaries(filtered.length > 0 ? filtered : Object.entries(sortedSummaries));
    }
  }, [searchTerm, visitState.data.summaries]);

  // Function to split text by search term
  const splitText = (text) => {
    if (!debouncedSearchTerm) return [text];
  
    const regex = new RegExp(`(${debouncedSearchTerm})`, 'gi');
    const parts = text.split(regex);
  
    // Return the original text as a single part if no matches are found
    if (parts.length === 1) {
      return [text];
    }
  
    return parts;
  };

  const handleNextResult = () => {
    if (currentResultIndex < resultsCount - 1) {
      setCurrentResultIndex(currentResultIndex + 1);
    }
  };
  
  const handlePrevResult = () => {
    if (currentResultIndex > 0) {
      setCurrentResultIndex(currentResultIndex - 1);
    }
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const toggleDetails = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    console.log('Templates data for visit:', visitState.data.templates);
  }, [visitState.data.templates]);

  const formatRecordingTime = (seconds) => {
    if (!seconds && seconds !== 0) return "00:00";

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = (seconds % 60).toFixed(0);
    return `${minutes} Minutes and ${remainingSeconds} Seconds`;
  };

  const summariesOrder = [
    "Chief Complaint",
    "Subjective",
    "Objective",
    "Risk Assessment",
    "Mental Status Exam",
    "Therapeutic Interventions",
    "Medications",
    "Family & Social history",
    "Assessment and Plan"
  ];

  function sortSummariesWithCustomOrder(generatedSummaries, fixedOrder) {
    if (!generatedSummaries) {
      console.error('generatedSummaries is undefined or null');
      return {};
    }
    
    const predefinedSummaries = {};
    const customSummaries = {};

    Object.keys(generatedSummaries).forEach(key => {
        if (fixedOrder.includes(key)) {
            predefinedSummaries[key] = generatedSummaries[key];
        } else {
            customSummaries[key] = generatedSummaries[key];
        }
    });

    // Sort predefined summaries according to the fixed order
    const orderedSummaries = {};
    fixedOrder.forEach(key => {
        if (predefinedSummaries[key]) {
            orderedSummaries[key] = predefinedSummaries[key];
        }
    });

    // Append custom summaries below predefined ones
    // Optionally, sort customSummaries here based on another criterion if desired
    Object.keys(customSummaries).forEach(key => {
        orderedSummaries[key] = customSummaries[key];
    });

    return orderedSummaries;
  }

  const handleMenuOpen = (event, summaryName) => {
    setMenuAnchorEl({ ...menuAnchorEl, [summaryName]: event.currentTarget });
  };
  
  // Handles menu closing and removes the anchor for the target summary
  const handleMenuClose = (summaryName) => {
    setMenuAnchorEl({ ...menuAnchorEl, [summaryName]: null });
  };


  const handleRegenerateSummary = async (summaryName) => {
    setIsRegenerating({ ...isRegenerating, [summaryName]: true });
    handleMenuClose(summaryName);

    try {
      const promptText = promptsData[summaryName]; 
      const combinedPrompt = `<prompt>\n${promptText}\n</prompt>\n\n<conversation>${visitState.data.transcript}\n</conversation>`; 
      console.log("combined prompt: ", combinedPrompt)
  
      const response = await fetch('https://stt-real-time-app-ea32710afdd5.herokuapp.com/openai', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: combinedPrompt })
      });
  
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  
      const newSummary = await response.json(); // Adjust based on the actual response format
  
      if (newSummary && newSummary.response) {
        // Updating local state
        const updatedSummaries = { ...visitState.data.summaries, [summaryName]: { ...visitState.data.summaries[summaryName], response: newSummary.response } };
        visitState.data.summaries = updatedSummaries; // Make sure this does not directly mutate the state
        setFilteredSummaries(Object.entries(sortSummariesWithCustomOrder(updatedSummaries, summariesOrder)));
  
        // Update Firestore
        const db = getFirestore();
        const summaryDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}`);

        const updateData = {};
        updateData[`summaries.${summaryName}`] = newSummary

        await updateDoc(summaryDocRef, updateData);
        console.log("Firestore summary updated successfully");
      }
      
    } catch (error) {
      console.error('Error regenerating summary:', error);
      setIsRegenerating({ ...isRegenerating, [summaryName]: false }); 
    } finally {
      setIsRegenerating({ ...isRegenerating, [summaryName]: false });
    }  
  };
  
  const handleMakeConcise = async (summaryName) => {
    setIsRegenerating({ ...isRegenerating, [summaryName]: true });
    handleMenuClose(summaryName);

    try {
      const originalSummary = visitState.data.summaries[summaryName].response;
      const concisePrompt = `Given the detailed summary below, create a more concise version that retains all essential information:\n\n"${originalSummary}`;
      console.log("combined prompt: ", concisePrompt)
  
      const response = await fetch('https://stt-real-time-app-ea32710afdd5.herokuapp.com/openai', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: concisePrompt })
      });
  
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  
      const newSummary = await response.json(); // Adjust based on the actual response format
  
      if (newSummary && newSummary.response) {
        // Updating local state
        const updatedSummaries = { ...visitState.data.summaries, [summaryName]: { ...visitState.data.summaries[summaryName], response: newSummary.response } };
        visitState.data.summaries = updatedSummaries; // Make sure this does not directly mutate the state
        setFilteredSummaries(Object.entries(sortSummariesWithCustomOrder(updatedSummaries, summariesOrder)));
  
        // Update Firestore
        const db = getFirestore();
        const summaryDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}`);

        const updateData = {};
        updateData[`summaries.${summaryName}`] = newSummary

        await updateDoc(summaryDocRef, updateData);
        console.log("Firestore summary updated successfully");
      }
      
    } catch (error) {
      console.error('Error regenerating summary:', error);
      setIsRegenerating({ ...isRegenerating, [summaryName]: false });
    } finally {
      setIsRegenerating({ ...isRegenerating, [summaryName]: false });
    }  
  };


  
  const handleDeleteSummary = async (summaryName) => {
    handleMenuClose(summaryName);

    try {
        // Updating local state
        const { [summaryName]: removedSummary, ...remainingSummaries } = visitState.data.summaries;
        const updatedVisitData = { ...visitState.data, summaries: remainingSummaries };
        setVisitState({ ...visitState, data: updatedVisitData });
        setFilteredSummaries(Object.entries(sortSummariesWithCustomOrder(remainingSummaries, summariesOrder)));

        // Update Firestore to remove the summary
        const db = getFirestore();
        const summaryDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}`);
        await updateDoc(summaryDocRef, {
            [`summaries.${summaryName}`]: deleteField() // Use deleteField() to remove the summary
        });

        console.log("Firestore summary deleted successfully");
    } catch (error) {
        console.error('Error deleting summary:', error);
        // Optionally, handle any UI feedback here, such as showing an error message
    }
  };

  const handleOpenTalkSummaries = (promptType) => {
    setOpenTalkToSummaries({ ...openTalkToSummaries, [promptType]: true });
    //setCurrentSummary(promptType);
  };

  const handleCloseTalkSummaries = (promptType) => {
      setOpenTalkToSummaries({ ...openTalkToSummaries, [promptType]: false });
      setRefineSummariesNotes(prevTexts => ({
          ...prevTexts,
          [promptType]: { text: '',}
        }));
  };

  const handleTextChangeSummaries = (promptType, newText) => {
    setRefineSummariesNotes(prevTexts => ({
      ...prevTexts,
      [promptType]: { text: newText,}
    }));
    console.log("refine summary notes: ", refineSummariesNotes)
  };

  const handleRecordingStatusChangeSums = (promptType, isListening) => {
    setIsRecordingToSummaries(prevStates => ({
        ...prevStates,
        [promptType]: isListening,
    }));    
  };

  const onRefineSummary = async (summaryName) => {
    setIsRegenerating(prevState => ({ ...prevState, [summaryName]: true }));
    console.log("refine summary: ", summaryName)

    const originalSummary = visitState.data.summaries[summaryName].response;
    const instruction = refineSummariesNotes[summaryName].text
    const InstructionPrompt = `Adjust the summary below based on the user's adjustment instruction.\nThe instruction can be found between the <instruction> tags, the summary that needs to be adjusted can be found between the <summary> tags and I will also provide the original transcript as reference in case this is needed, this transcript can be found between the <transcript> tags.\n\nThe user's adjustment instruction:\n<instruction>\n${instruction}\n</instruction> \n\nThe summary:\n<summary>\n${originalSummary}\n</summary>\n\nThe original transcript as reference:\n<transcript>\n${visitState.data.transcript}\n</transcript>\n\nMake sure to directly output the content without any title(s) or tags.`;
    console.log("summary", summaryName);
    console.log("instrction", instruction);
    console.log("all tog: ", InstructionPrompt )
    
    try {
        const response = await fetch('https://stt-real-time-app-ea32710afdd5.herokuapp.com/openai', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prompt: InstructionPrompt })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const newSummary = await response.json(); // Adjust based on the actual response format
  
        if (newSummary && newSummary.response) {
          // Updating local state
          const updatedSummaries = { ...visitState.data.summaries, [summaryName]: { ...visitState.data.summaries[summaryName], response: newSummary.response } };
          visitState.data.summaries = updatedSummaries; // Make sure this does not directly mutate the state
          setFilteredSummaries(Object.entries(sortSummariesWithCustomOrder(updatedSummaries, summariesOrder)));
    
          // Update Firestore
          const db = getFirestore();
          const summaryDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}`);

          const updateData = {};
          updateData[`summaries.${summaryName}`] = newSummary

          await updateDoc(summaryDocRef, updateData);
          console.log("Firestore summary updated successfully");
        }
      
    } catch (error) {
      console.error('Error regenerating summary:', error);
      setIsRegenerating({ ...isRegenerating, [summaryName]: false }); 
    } finally {
      setIsRegenerating({ ...isRegenerating, [summaryName]: false });
    }  
  };
  

  
  const handleMenuOpenTemplate = (event, summary) => {
    setMenuAnchorElTemplate({ ...menuAnchorElTemplate, [summary]: event.currentTarget });
  };
  
  // Handles menu closing and removes the anchor for the target summary
  const handleMenuCloseTemplate = (summary) => {
    setMenuAnchorElTemplate({ ...menuAnchorElTemplate, [summary]: null });
  };

  const handleRegenerateTemplateSummary = async (templateId, summary, uniqueKey) => {
    setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: true });
    handleMenuCloseTemplate(uniqueKey);

    const templateSummaryPrompt = templates.find(t => t.id === templateId).associatedPrompts.find(s => s.id === summary.id).content;
    const combinedPrompt = `<prompt>\n${templateSummaryPrompt}\n</prompt>\n\n<conversation>${visitState.data.transcript}\n</conversation>`; 
    console.log("combined prompt template: ", combinedPrompt)

    try {
      const response = await fetch('https://stt-real-time-app-ea32710afdd5.herokuapp.com/openai', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: combinedPrompt })
      });
  
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  
      const newSummary = await response.json(); // Adjust based on the actual response format
      
      if (newSummary && newSummary.response) {
        // Updating local state
        const updatedTemplates = { ...visitState.data.templates };
        const templateIndex = updatedTemplates[templateId].findIndex(s => s.id === summary.id);
        if (templateIndex !== -1) {
            updatedTemplates[templateId][templateIndex].data.response = newSummary.response;
        }

        setVisitState({ ...visitState, data: { ...visitState.data, templates: updatedTemplates } });
        // Update Firestore
        
        const db = getFirestore();
        const templateDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}/templates/${templateId}`);
        await updateDoc(templateDocRef, {
          [`templateSummaries.${summary.id}.response`]: newSummary.response 
        });

        console.log("Firestore template summary updated successfully");
      }
      
    } catch (error) {
      console.error('Error regenerating summary:', error);
      setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: false });
    } finally {
      setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: false });
    }  
  };


  const handleMakeTemplateConcise = async (templateId, summary, uniqueKey) => {
    setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: true });
    handleMenuCloseTemplate(uniqueKey);

    const originalSummary = visitState.data.templates[templateId].find(s => s.id === summary.id).data.response;
    const concisePrompt = `Given the detailed summary below, create a more concise version that retains all essential information:\n\n"${originalSummary}`;
    console.log("combined prompt template: ", concisePrompt)

    try {
      const response = await fetch('https://stt-real-time-app-ea32710afdd5.herokuapp.com/openai', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: concisePrompt })
      });
  
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  
      const newSummary = await response.json(); // Adjust based on the actual response format
      
      if (newSummary && newSummary.response) {
        // Updating local state
        const updatedTemplates = { ...visitState.data.templates };
        const templateIndex = updatedTemplates[templateId].findIndex(s => s.id === summary.id);
        if (templateIndex !== -1) {
            updatedTemplates[templateId][templateIndex].data.response = newSummary.response;
        }

        setVisitState({ ...visitState, data: { ...visitState.data, templates: updatedTemplates } });
        // Update Firestore
        
        const db = getFirestore();
        const templateDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}/templates/${templateId}`);
        await updateDoc(templateDocRef, {
          [`templateSummaries.${summary.id}.response`]: newSummary.response 
        });

        console.log("Firestore template summary updated successfully");
      }
      
    } catch (error) {
      console.error('Error regenerating summary:', error);
      setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: false });
    } finally {
      setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: false });
    }  
  };

  const handleDeleteTemplateSummary = async (templateId, summary, uniqueKey) => {
    // Close any open menu
    handleMenuCloseTemplate(uniqueKey);

    try {
        // Updating local state
        const updatedTemplates = { ...visitState.data.templates };
        const templateIndex = updatedTemplates[templateId].findIndex(s => s.id === summary.id);
        if (templateIndex !== -1) {
            updatedTemplates[templateId].splice(templateIndex, 1); // Remove the summary from the array
        }
        setVisitState({ ...visitState, data: { ...visitState.data, templates: updatedTemplates } });

        // Update Firestore to remove the template summary
        const db = getFirestore();
        const templateDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}/templates/${templateId}`);
        
        // Note: Firestore doesn't directly support array removal by index, so you're updating the entire template.
        await updateDoc(templateDocRef, {
            [`templateSummaries.${summary.id}`]: deleteField()
        });

        console.log("Firestore template summary deleted successfully");
    } catch (error) {
        console.error('Error deleting template summary:', error);
        // Optionally, handle any UI feedback here, such as showing an error message
    }
  };

  const handleOpenTalkTemplates = (promptType) => {
    setOpenTalkToNotes({ ...openTalkToNotes, [promptType]: true });
    //setCurrentSummary(promptType);
  };

  const handleCloseTalkTemplates = (promptType) => {
      setOpenTalkToNotes({ ...openTalkToNotes, [promptType]: false });
      setRefineTemplateNotes(prevTexts => ({
          ...prevTexts,
          [promptType]: { text: '',}
        }));
  };

  const handleTextChange = (promptType, newText) => {
    setRefineTemplateNotes(prevTexts => ({
      ...prevTexts,
      [promptType]: { text: newText,}
    }));
    console.log("refine notes: ", refineTemplateNotes)
  };

  // Callback function to update recording status of talking to notes 
  const handleRecordingStatusChange = (promptType, isListening) => {
    setIsRecordingToTemplates(prevStates => ({
        ...prevStates,
        [promptType]: isListening,
    }));    
  };

  const onRefineTemplate = async (templateId, summary, uniqueKey) => {
    setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: true });

    // Assuming you have a state or method to get the current text you want to refine for the template's summary
    const originalText = visitState.data.templates[templateId].find(s => s.id === summary.id)?.data.response;
    const instruction = refineTemplateNotes[uniqueKey]?.text;

    // Construct the prompt for refining the text
    const refinePrompt = `Adjust the summary below based on the user's adjustment instruction.\nThe instruction can be found between the <instruction> tags, the summary can be found between the <summary> tags and I will also provide the original transcript as reference in case this is needed, this transcript can be found between the <transcript> tags.\n\nThe user's adjustment instruction:\n<instruction>\n${instruction}\n</instruction> \n\nThe summary:\n<summary>\n${originalText}\n</summary>\n\nThe original transcript as reference:\n<transcript>\n${visitState.data.transcript}\n</transcript>\n\nMake sure to directly output the content without any title(s).`;
    console.log("refined prompt :", refinePrompt)
    try {
        const response = await fetch('https://stt-real-time-app-ea32710afdd5.herokuapp.com/openai', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ prompt: refinePrompt })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const { response: refinedText } = await response.json();

        // Updating local state with the refined summary
        const updatedTemplates = { ...visitState.data.templates };
        const summaryIndex = updatedTemplates[templateId].findIndex(s => s.id === summary.id);
        if (summaryIndex !== -1) {
            updatedTemplates[templateId][summaryIndex].data.response = refinedText;
        }

        setVisitState({ ...visitState, data: { ...visitState.data, templates: updatedTemplates } });

        const db = getFirestore();
        const templateDocRef = doc(db, `users/${userId}/summaries/${selectedPatient}/visits/${visitState.id}/templates/${templateId}`);
        await updateDoc(templateDocRef, {
          [`templateSummaries.${summary.id}.response`]: refinedText
        });

        console.log("Template summary refined and updated successfully.");
    } catch (error) {
        console.error('Error refining template summary:', error);
        setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: false });
    } finally {
        setIsRegeneratingTemplate({ ...isRegeneratingTemplate, [uniqueKey]: false });
    }
  };





  return (
    <Card >
      <SoftBox bgColor="light" p={2} mb={1} variant="contained" onClick={toggleDetails} sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
        <SoftBox>
          <SoftTypography variant="subtitle2">{visitState.id}</SoftTypography>
        </SoftBox>
        <SoftBox>
            <SoftTypography color="text" variant="subtitle2">{visitState.data.timestamp}</SoftTypography>
        </SoftBox>
      </SoftBox>
      {isExpanded && (
         <SoftBox mb={2} >
          <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={0} px={2} mb={1} mt={{xl: 2, xxl: 4}}>
            {/* Info Details */}
            <SoftBox display="flex" alignItems="center" pl={1}>
              <SoftBadge
                variant="contained"
                color="secondary"
                size="sm"
                badgeContent={
                  <SoftTypography variant="h6" fontWeight="medium">
                    {visitState.id}
                  </SoftTypography>
                }
                circular
                container
              />
              <SoftTypography variant="h6" pl={1}>
                on {visitState.data.timestamp}
              </SoftTypography>
            </SoftBox>

            {/* AppBar with Tabs */}
            <SoftBox pr={2} width='50%'>
              <AppBar position="static" >
                <Tabs value={currentTab} onChange={handleTabChange} aria-label="Visit tabs">
                  <Tab label="Summaries" />
                  <Tab label="Templates" />
                  <Tab label="Transcript" />
                  <Tab label="Emails" />
                </Tabs>
              </AppBar>
            </SoftBox>
          </SoftBox>
          <SoftBox pl={4} mb={1} >
            <SoftTypography variant="button" color="text"  >
              {formatRecordingTime(visitState.data.recordingTime)}
            </SoftTypography>
          </SoftBox>
          <SoftBox display="flex" justifyContent="center" alignItems="center" pt={2} pb={4} sx={{boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)' }} >
              <SoftBox width="50%" textAlign="center">
                  <SoftInput
                      placeholder={currentTab === 0 ? "Search in summaries..." : currentTab === 1 ? "Search in templates..." : "search in transcript" }
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        if (currentTab === 0) {
                          setCurrentResultIndex(0);
                        } else if (currentTab === 1) {
                          setTemplateCurrentResultIndex(0);
                        }
                      }}
                      icon={{ component: "search", direction: "left" }}
                      endAdornment={(
                        <SoftBox display="flex" alignItems="center" >
                          {currentTab === 0 && resultsCount > 0 && (
                            <>
                              <IconButton onClick={() => setCurrentResultIndex(Math.max(currentResultIndex - 1, 0))} disabled={currentResultIndex === 0}>
                                <ArrowBackIcon />
                              </IconButton>
                              <SoftTypography variant="button" sx={{ mx: 1 }}>
                                {currentResultIndex + 1} of {resultsCount}
                              </SoftTypography>
                              <IconButton onClick={() => setCurrentResultIndex(Math.min(currentResultIndex + 1, resultsCount - 1))} disabled={currentResultIndex === resultsCount - 1}>
                                <ArrowForwardIcon />
                              </IconButton>
                            </>
                          )}
                          {currentTab === 1 && templateResultsCount > 0 && (
                            <>
                              <IconButton onClick={() => setTemplateCurrentResultIndex(Math.max(templateCurrentResultIndex - 1, 0))} disabled={templateCurrentResultIndex === 0}>
                                <ArrowBackIcon />
                              </IconButton>
                              <SoftTypography variant="button" sx={{ mx: 1 }}>
                                {templateCurrentResultIndex + 1} of {templateResultsCount}
                              </SoftTypography>
                              <IconButton onClick={() => setTemplateCurrentResultIndex(Math.min(templateCurrentResultIndex + 1, templateResultsCount - 1))} disabled={templateCurrentResultIndex === templateResultsCount - 1}>
                                <ArrowForwardIcon />
                              </IconButton>
                            </>
                          )}
                        </SoftBox>
                      )}
                    />
              </SoftBox>
              {/*<SoftBox pl={1} >
                <SoftButton variant="outlined" color="dark" size="medium" startIcon={<ForwardToInboxOutlinedIcon sx={{ mr:1}} />} >
                  Send email 
                </SoftButton>
              </SoftBox>*/}
              { currentTab === 0 && (
                <SoftBox pl={1}>

                  <SoftButton
                    sx={{
                      px: 5,
                      '.MuiButton-startIcon': { // Adjusting the start icon styles
                        marginRight: '8px', // Increase space between text and icon
                        position: 'relative',
                        top: '-2px' // Position the icon a bit higher
                      }
                    }}
                    onClick={handleCopyAllSummaries}
                    variant={copyAllSummary ? "outlined" : "contained" }
                    color="dark"
                    size="medium"
                    startIcon={copyAllSummary ? <Icon>check</Icon> : <Icon>copy</Icon>} 
                  >
                    {copyAllSummary ? "Copied!" : "Copy All"}
                  </SoftButton>
                  
                  <SoftButton sx={{ml:1}} variant={copySelectedSummary ? "outlined" : "contained" } color="dark" size="medium" startIcon={copySelectedSummary ? <Icon>check</Icon> : <Icon>copy</Icon>}  onClick={copySelectedSummaries}>
                    {copySelectedSummary ? "Copied!" : "Copy Selected Summaries" }
                  </SoftButton>
                </SoftBox>
                )
              }
              { currentTab === 1 && (
                <SoftBox pl={1}>
                  <SoftButton
                    sx={{
                      px: 5,
                      '.MuiButton-startIcon': { 
                        marginRight: '8px', 
                        position: 'relative',
                        top: '-2px' 
                      }
                    }}
                    onClick={handleCopyAllTemplateSummaries}
                    variant={copyAllTemplate ? "outlined" : "contained" }
                    color="dark"
                    size="medium"
                    startIcon={copyAllTemplate ? <Icon>check</Icon> : <Icon>copy</Icon>} 
                  >
                     {copyAllTemplate ? "Copied!" : "Copy All"}
                  </SoftButton>
                  <SoftButton sx={{ml:1}} variant={copySelectedTemplateSums ? "outlined" : "contained" } color="dark" size="medium" startIcon={copySelectedTemplateSums ? <Icon>check</Icon> : <Icon>copy</Icon>}  onClick={copySelectedTemplateSummaries}>
                    {copySelectedTemplateSums ? "Copied!" : "Copy Selected Summaries" }
                  </SoftButton>
                </SoftBox>
                )
              }
          </SoftBox>
          {currentTab === 0 && (
            <SoftBox sx={{ padding: '20px', maxHeight: '600px', overflowY: 'auto' }}>
              {filteredSummaries.length > 0 ? (
                filteredSummaries.map(([summaryName, summaryDetails], index) => (
                  <SoftBox key={index} sx={{ marginBottom: '20px' }}>
                    {/*<Checkbox
                      checked={!!selectedSummaries[summaryName]}
                      onChange={() => toggleSummarySelection(summaryName)}
                      inputProps={{ 'aria-label': 'select summary' }}
                />*/}
                    <SoftBadge
                      variant="contained"
                      color="warning"
                      size="md"
                      sx={{ pl: 4, mb: -2}}
                      badgeContent={
                        <SoftBox display="flex" alignItems="center" justifyContent="space-between" width="100%">
                          <SoftTypography sx={{ ml: 2}} variant="h6" >{summaryName}</SoftTypography>
                          <Tooltip title="open menu" placement="top">
                            <IconButton 
                              color="inherit" // Adjust the color as needed
                              onClick={(e) => handleMenuOpen(e, summaryName)}
                              sx={{
                                transition: "0.3s ease-in-out",
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.14)", 
                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", 
                                },
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </Tooltip>
                          <Menu
                            anchorEl={menuAnchorEl[summaryName]}
                            open={Boolean(menuAnchorEl[summaryName])}
                            onClose={() => handleMenuClose(summaryName)}
                          >
                            <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Regeneration is available for Platinum and Gold Package subscribers only." : ""} placement="top">
                                <div> {/* Wrap the MenuItem in a div for tooltip functionality on a potentially disabled item */}
                                    <MenuItem onClick={currentUserSubscription !== "Silver Subscription" ? () => handleRegenerateSummary(summaryName) : null} disabled={currentUserSubscription === "Silver Subscription"}>
                                        <ListItemIcon>
                                            <LoopOutlinedIcon fontSize="small" sx={{ color: currentUserSubscription === "Silver Subscription" ? 'action.disabled' : '#344767' }} />
                                        </ListItemIcon>
                                        <ListItemText>
                                            <SoftTypography color={currentUserSubscription === "Silver Subscription" ? "text.disabled" : "dark"} variant="button" fontWeight="medium">
                                                Regenerate Note
                                            </SoftTypography>
                                        </ListItemText>
                                    </MenuItem>
                                </div>
                            </Tooltip>

                            <MenuItem onClick={() => handleMakeConcise(summaryName)}>
                              <ListItemIcon>
                                  <SummarizeOutlinedIcon fontSize="small" sx={{ color: '#344767' }} />
                              </ListItemIcon>
                              <ListItemText>
                                  <SoftTypography color="dark" variant="button" fontWeight="medium">
                                      Make Concise
                                  </SoftTypography>
                              </ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => handleDeleteSummary(summaryName)} >
                              <ListItemIcon>
                                  <DeleteOutlinedIcon fontSize="small" sx={{ color: "red" }} />
                              </ListItemIcon>
                              <ListItemText>
                                  <SoftTypography color="error" variant="button" fontWeight="medium">
                                  Delete
                                  </SoftTypography>
                              </ListItemText>
                            </MenuItem>
                          </Menu>
                        </SoftBox>
                      }
                      //circular
                      //container
                    />
                    <SoftBox p={2}>
                      <Card sx={{ minHeight:"120px", padding: '20px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>

                        {
                          editMode[summaryName] ? (
                            <SoftBox pb={3} display="flex" justifyContent="space-between" alignItems="center">
                              <SoftBadge
                                  variant="contained"
                                  color="secondary"
                                  size="md"
                                  badgeContent={
                                    <SoftTypography variant="button" fontWeight="medium" >
                                      Editing Mode
                                    </SoftTypography>
                                  }
                                  //circular
                                  container
                              />
                              <SoftBox>
                                <SoftButton size="small" color="dark" onClick={() => handleSaveSummary(summaryName)}  sx={{ marginRight: '15px' }}>
                                  Save
                                </SoftButton>
                                <SoftButton size="small" color="light" onClick={() => handleCancel(summaryName)} >
                                  Cancel
                                </SoftButton>
                              </SoftBox>
                            </SoftBox>
                          ) : (
                            <SoftBox >
                              <SoftBox display="flex" justifyContent="center" alignItems="center" >
                                {showSaveSuccess[summaryName] && (
                                  <SoftBadge 
                                    variant="contained" 
                                    color="success" 
                                    size="sm" 
                                    sx={{ mb: 3 }} // Adjust based on your design needs
                                    badgeContent={<SoftTypography fontWeight="medium" variant="button" >Changes saved successfully!</SoftTypography>} 
                                    container 
                                  />
                                )}
                              </SoftBox>
                              {showSaveError[summaryName] && (
                                <SoftBox pb={5} px={5} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                  <SoftBadge 
                                    variant="contained" 
                                    color="error" 
                                    size="sm" 
                                    sx={{ mb: 3, mt:3 }} // Adjust based on your design needs
                                    badgeContent={<SoftTypography fontWeight="medium" variant="button" >Error saving summary!</SoftTypography>} 
                                    container 
                                  />
                                  <SoftTypography textAlign="center" variant="h6" >
                                    An error occured while saving the summary, please check your internet connection and try again or report this problem if this keeps appearing.
                                  </SoftTypography>
                                  <SoftTypography onClick={handleOpenModal} textAlign="center" sx={{ mt:3, textDecoration: "underline", cursor: 'pointer' }} variant="button" >
                                    Report this problem.
                                  </SoftTypography>
                                  <ReportProblemModal open={isModalOpen} onClose={handleCloseModal} />
                                </SoftBox>
                              )}
                              <Tooltip title="Edit Summary" placement="right">
                                <SoftButton onClick={() => handleEditClick(summaryName, summaryDetails)} iconOnly color="light" sx={{ position: 'absolute', top: '15px', right: '15px' }}>
                                  <Icon >
                                      edit
                                  </Icon>
                                </SoftButton>
                              </Tooltip>
                              <Tooltip title="Copy Summary" placement="right">
                                <SoftButton
                                  onClick={() => handleCopySummary(summaryName, summaryDetails.response)}
                                  iconOnly
                                  color="dark" 
                                  sx={{ position: 'absolute', top: '65px', right: '15px' }} 
                                >
                                  <Icon>{copySummary[summaryName] ? "check" : "copy" }</Icon> 
                                </SoftButton>
                              </Tooltip>
                              <Tooltip title= { selectedSummaries[summaryName] ? "Un-select Summary" : "Select summary" } placement="right">
                                <SoftButton
                                  onClick={() => toggleSummarySelection(summaryName)}
                                  variant="contained"
                                  iconOnly
                                  circular="true"
                                  color={selectedSummaries[summaryName] ? 'success' : 'warning'}
                                  sx={{ position: 'absolute', top: '120px', right: '15px' }} 
                                >
                                  <Icon>
                                    {selectedSummaries[summaryName] ? 'check_circle' : 'check_circle_outline'}
                                  </Icon>
                                </SoftButton>
                              </Tooltip>
                            </SoftBox>
                          )
                        }
                        {isRegenerating[summaryName] ? (
                          <SoftBox mb={4} mt={4} style={{ display: 'flex', justifyContent: 'center' }}>
                              <ClockLoader color="#344767" speedMultiplier={0.7} size={80} />
                          </SoftBox>
                        
                        ) :  editMode[summaryName] ? (
                            <textarea
                              value={editedText[summaryName]}
                              onChange={(e) => setEditedText({ ...editedText, [summaryName]: e.target.value })}
                              rows={10}
                              style={{ 
                                  width: '100%',
                                  minHeight: '100px',
                                  border: '1px solid #ccc',
                                  borderRadius: '8px',
                                  padding: '15px',
                                  fontSize: '16px',
                                  fontFamily: 'Arial, sans-serif',
                                  backgroundColor: '#fff',
                                  color: '#333',
                                  boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                  lineHeight: '1.5',

                              }}
                            />
                          ) : (

                            <SoftTypography pr={10} variant="body2" style={{ whiteSpace: 'pre-wrap', minHeight: '140px' }}>
                              {splitText(String(summaryDetails.response)).map((part, partIndex) => 
                                part.toLowerCase() === searchTerm.toLowerCase() ? 
                                  <span key={partIndex} style={{ backgroundColor: currentResultIndex === Math.floor(partIndex / 2) ? 'yellow' : 'lightblue' }}>{part}</span> : 
                                part
                              )}
                            </SoftTypography>
                          )
                        }
                        {!openTalkToSummaries[summaryName] ? (
                            <SoftBox pt={3} display="flex" alignItems="center" justifyContent="flex-end">
                                <SoftButton 
                                    onClick={() => handleOpenTalkSummaries(summaryName)}
                                    color="dark"
                                    variant="outlined"
                                >
                                    <QuestionAnswerOutlinedIcon fontSize="small" sx={{ color: '#344767', mr: 1 }} />
                                    Talk to Note
                                </SoftButton>
                            </SoftBox>
                        ) : (
                            <SoftBox style={{padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '8px', margin: '20px 0'}}>
                                <SoftBox display="flex" alignItems="center" justifyContent="space-between" >
                                    <SoftBox display="flex" alignItems="center">
                                        <VolumeUpIcon sx={{ color: '#333', mr: 1 }} />
                                        <SoftTypography variant="h6" style={{color: '#333'}}>
                                            Talking to {summaryName}
                                        </SoftTypography>
                                    </SoftBox>
                                    <SoftButton color="dark" size="inherit" variant="outlined" onClick={() => (handleCloseTalkSummaries(summaryName))} > 
                                        <CloseIcon />
                                    </SoftButton>
                                </SoftBox>
                                <div>
                                    <SpeechToTextSummaries 
                                        promptType={summaryName}
                                        onTextChange={(summaryName, text) => handleTextChangeSummaries(summaryName, text)}
                                        onRecordingStatusChange={handleRecordingStatusChangeSums}                                                                          
                                    />
                                </div>
                                {isRecordingToSummaries[summaryName] && (
                                    <SoftBox pt={2} mb={-1} display="flex" alignItems="center" justifyContent="center" > 
                                        <ScaleLoader speedMultiplier={0.8} height={15} width={3} color="#344767" /> 
                                    </SoftBox>
                                )}
                                <SoftBox pt={3} display="flex" alignItems="center" justifyContent="center">
                                    <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : isRecordingToSummaries[summaryName] ? "Stop recording to refine note" : ""} placement="right">
                                        <span>
                                            <SoftButton disabled={!!isRecordingToSummaries[summaryName] || currentUserSubscription === "Silver Subscription"} onClick={() => currentUserSubscription !== "Silver Subscription" ? onRefineSummary(summaryName) : null} color="dark" variant="contained" startIcon={<AutoAwesomeOutlinedIcon sx={{ mr: 1 }}/>}>
                                                Re-Fine Note 
                                            </SoftButton>
                                        </span>
                                    </Tooltip>
                                </SoftBox>

                                {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                                    <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                    <SoftBadge
                                        variant="contained"
                                        color="error"
                                        size="md"
                                        badgeContent={
                                            <SoftTypography variant="button">
                                                🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                            </SoftTypography>
                                        }
                                        container
                                    />
                                    </SoftBox>
                                )}
                            </SoftBox>
                        )}
                      </Card>
                    </SoftBox>
                  </SoftBox>
                ))
              ) : (
                <Card sx={{ marginBottom: '20px', padding: '16px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                  <SoftBox textAlign="center" p={2}>
                    <SoftTypography variant="body2">
                      No summaries generated for this visit.
                    </SoftTypography>
                  </SoftBox>
                </Card>
              )}
            </SoftBox>
          )}
          {currentTab === 1 && (
              <SoftBox sx={{ padding: '20px', maxHeight: '600px', overflowY: 'auto' }}>
                  {Object.entries(visitState.data.templates || {}).length > 0 ? (
                      Object.entries(visitState.data.templates).map(([templateName, templateData], index) => (
                          <SoftBox key={index} sx={{ marginBottom: '20px' }}>
                              <SoftTypography color="text" variant="h5" ml={2} mb={2} >{templateName}</SoftTypography>
                              {/*<Card sx={{ padding: '16px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>*/}
                                {templateSummariesOrder && templateSummariesOrder.length > 0 ? (
                                  templateSummariesOrder.map((summaryId) => {
                                    // Find the summary in templateData by ID
                                    const summary = templateData.find(s => s.id === summaryId);
                                    if (!summary) return null; // Skip rendering if the summary is not found

                                    const uniqueKey = `${templateName}-${summary.id}`;
                                        return (
                                          <SoftBox key={uniqueKey} p={2} mb={1}>
                                              <SoftBadge
                                                variant="contained"
                                                color="warning"
                                                size="md"
                                                sx={{ pl: 2 }}
                                                badgeContent={
                                                  <SoftBox display="flex" alignItems="center" justifyContent="space-between" width="100%">
                                                    <SoftTypography sx={{ ml: 2}} variant="h6" >{summary.id}</SoftTypography>
                                                    <Tooltip title="open menu" placement="top">
                                                      <IconButton 
                                                        color="inherit" // Adjust the color as needed
                                                        onClick={(e) => handleMenuOpenTemplate(e, uniqueKey)}
                                                        sx={{
                                                          transition: "0.3s ease-in-out",
                                                          "&:hover": {
                                                            backgroundColor: "rgba(0, 0, 0, 0.14)", 
                                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", 
                                                          },
                                                        }}
                                                      >
                                                        <MoreVertIcon />
                                                      </IconButton>
                                                    </Tooltip>
                                                    <Menu
                                                      anchorEl={menuAnchorElTemplate[uniqueKey]}
                                                      open={Boolean(menuAnchorElTemplate[uniqueKey])}
                                                      onClose={() => handleMenuCloseTemplate(uniqueKey)}
                                                    >
                                                      <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Regeneration is available for Platinum and Gold Package subscribers only." : ""} placement="top">
                                                          <div> {/* Wrap the MenuItem in a div for tooltip functionality on a potentially disabled item */}
                                                              <MenuItem onClick={currentUserSubscription !== "Silver Subscription" ? () => handleRegenerateTemplateSummary(templateName, summary, uniqueKey) : null} disabled={currentUserSubscription === "Silver Subscription"}>
                                                                  <ListItemIcon>
                                                                      <LoopOutlinedIcon fontSize="small" sx={{ color: currentUserSubscription === "Silver Subscription" ? 'action.disabled' : '#344767' }} />
                                                                  </ListItemIcon>
                                                                  <ListItemText>
                                                                      <SoftTypography color={currentUserSubscription === "Silver Subscription" ? "text.disabled" : "dark"} variant="button" fontWeight="medium">
                                                                          Regenerate Note
                                                                      </SoftTypography>
                                                                  </ListItemText>
                                                              </MenuItem>
                                                          </div>
                                                      </Tooltip>

                                                      <MenuItem onClick={() => handleMakeTemplateConcise(templateName, summary, uniqueKey)}>
                                                        <ListItemIcon>
                                                            <SummarizeOutlinedIcon fontSize="small" sx={{ color: '#344767' }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="dark" variant="button" fontWeight="medium">
                                                                Make Concise
                                                            </SoftTypography>
                                                        </ListItemText>
                                                      </MenuItem>
                                                      <MenuItem onClick={() => handleDeleteTemplateSummary(templateName, summary, uniqueKey)} >
                                                        <ListItemIcon>
                                                            <DeleteOutlinedIcon fontSize="small" sx={{ color: "red" }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="error" variant="button" fontWeight="medium">
                                                            Delete
                                                            </SoftTypography>
                                                        </ListItemText>
                                                      </MenuItem>
                                                    </Menu>
                                                  </SoftBox>
                                                }
                                                //circular
                                                //container
                                              />
                                              {/*<SoftTypography variant="subtitle2" mb={1} sx={{ marginLeft: '20px' }}>{summary.id}</SoftTypography>*/}
                                              <Card sx={{ minHeight: "120px", padding: '20px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                                                {
                                                  editModeTemplate[uniqueKey] ? (
                                                    <SoftBox pb={3} display="flex" justifyContent="space-between" alignItems="center">
                                                      <SoftBadge
                                                          variant="contained"
                                                          color="secondary"
                                                          size="md"
                                                          badgeContent={
                                                            <SoftTypography variant="button" fontWeight="medium" >
                                                              Editing Mode
                                                            </SoftTypography>
                                                          }
                                                          //circular
                                                          container
                                                      />
                                                      <SoftBox>
                                                        <SoftButton size="small" color="dark" onClick={() => handleSaveTemplate(templateName, summary)}  sx={{ marginRight: '15px' }}>
                                                          Save
                                                        </SoftButton>
                                                        <SoftButton size="small" color="light" onClick={() => handleCancelTemplate(templateName, summary)} >
                                                          Cancel
                                                        </SoftButton>
                                                      </SoftBox>
                                                    </SoftBox>
                                                  ) : (
                                                    <SoftBox >
                                                      <SoftBox display="flex" justifyContent="center" alignItems="center" >
                                                        {showSaveSuccessTemplate[uniqueKey] && (
                                                          <SoftBadge 
                                                            variant="contained" 
                                                            color="success" 
                                                            size="sm" 
                                                            sx={{ mb: 3 }} // Adjust based on your design needs
                                                            badgeContent={<SoftTypography fontWeight="medium" variant="button" >Changes saved successfully!</SoftTypography>} 
                                                            container 
                                                          />
                                                        )}
                                                      </SoftBox>
                                                      {showSaveErrorTemplate[uniqueKey] && (
                                                        <SoftBox pb={5} px={5} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                                          <SoftBadge 
                                                            variant="contained" 
                                                            color="error" 
                                                            size="sm" 
                                                            sx={{ mb: 3, mt:3 }} // Adjust based on your design needs
                                                            badgeContent={<SoftTypography fontWeight="medium" variant="button" >Error saving template summary!</SoftTypography>} 
                                                            container 
                                                          />
                                                          <SoftTypography textAlign="center" variant="h6" >
                                                            An error occured while saving the template summary, please check your internet connection and try again or report this problem if this keeps appearing.
                                                          </SoftTypography>
                                                          <SoftTypography onClick={handleOpenModal} textAlign="center" sx={{ mt:3, textDecoration: "underline", cursor: 'pointer' }} variant="button" >
                                                            Report this problem.
                                                          </SoftTypography>
                                                          <ReportProblemModal open={isModalOpen} onClose={handleCloseModal} />
                                                        </SoftBox>
                                                      )}
                                                      <Tooltip title="Edit Summary" placement="right">
                                                        <SoftButton onClick={() => handleEditTemplate(templateName, summary)} iconOnly color="light" sx={{ position: 'absolute', top: '15px', right: '15px' }}>
                                                          <Icon >
                                                              edit
                                                          </Icon>
                                                        </SoftButton>
                                                      </Tooltip>
                                                      <Tooltip title="Copy Summary" placement="right">
                                                        <SoftButton
                                                          onClick={() => handleCopySummaryTemplate(summary.id, summary.data.response)}
                                                          iconOnly
                                                          color="dark" 
                                                          sx={{ position: 'absolute', top: '65px', right: '15px' }} 
                                                        >
                                                          <Icon>{copyTemplateSummary[summary.id] ? "check" : "copy" }</Icon> 
                                                        </SoftButton>
                                                      </Tooltip>
                                                      <Tooltip title={selectedTemplateSummaries[templateName]?.[summary.id] ? "Un-select Summary" : "Select Summary"} placement="right">
                                                        <SoftButton
                                                          onClick={() => toggleTemplateSummarySelection(templateName, summary.id)}
                                                          variant="contained"
                                                          iconOnly
                                                          circular="true"
                                                          color={selectedTemplateSummaries[templateName]?.[summary.id] ? 'success' : 'warning'}
                                                          sx={{ position: 'absolute', top: '120px', right: '15px' }} 
                                                        >
                                                          <Icon>
                                                            {selectedTemplateSummaries[templateName]?.[summary.id] ? 'check_circle' : 'check_circle_outline'}
                                                          </Icon>
                                                        </SoftButton>
                                                      </Tooltip>
                                                    </SoftBox>
                                                  )
                                                }
                                                { isRegeneratingTemplate[uniqueKey] ? (
                                                  <SoftBox mb={4} mt={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                                      <ClockLoader color="#344767" speedMultiplier={0.7} size={80} />
                                                  </SoftBox>
                                                ) : editModeTemplate[uniqueKey] ? (
                                                    <textarea
                                                      value={editedTextTemplate[summary]}
                                                      onChange={(e) => setEditedTextTemplate({ ...editedTextTemplate, [summary]: e.target.value })}
                                                      rows={10}
                                                      style={{ 
                                                          width: '100%',
                                                          minHeight: '100px',
                                                          border: '1px solid #ccc',
                                                          borderRadius: '8px',
                                                          padding: '15px',
                                                          fontSize: '16px',
                                                          fontFamily: 'Arial, sans-serif',
                                                          backgroundColor: '#fff',
                                                          color: '#333',
                                                          boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                                          lineHeight: '1.5',

                                                      }}
                                                    />
                                                  ) : (

                                                    <SoftTypography pr={10} variant="body2" style={{ whiteSpace: 'pre-wrap', minHeight: '140px' }}>
                                                        {splitText(String(summary.data.response)).map((part, partIndex) => 
                                                            part.toLowerCase() === searchTerm.toLowerCase() ? 
                                                            <span key={partIndex} style={{ backgroundColor: templateCurrentResultIndex === Math.floor(partIndex / 2) ? 'yellow' : 'lightblue' }}>{part}</span> : 
                                                            part
                                                        )}
                                                    </SoftTypography>
                                                  )
                                                }
                                                {!openTalkToNotes[uniqueKey] ? (
                                                    <SoftBox pt={3} display="flex" alignItems="center" justifyContent="flex-end">
                                                        <SoftButton 
                                                            onClick={() => handleOpenTalkTemplates(uniqueKey)}
                                                            color="dark"
                                                            variant="outlined"
                                                        >
                                                            <QuestionAnswerOutlinedIcon fontSize="small" sx={{ color: '#344767', mr: 1 }} />
                                                            Talk to Note
                                                        </SoftButton>
                                                    </SoftBox>
                                                ) : (
                                                    <SoftBox style={{padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '8px', margin: '20px 0'}}>
                                                        <SoftBox display="flex" alignItems="center" justifyContent="space-between" >
                                                            <SoftBox display="flex" alignItems="center">
                                                                <VolumeUpIcon sx={{ color: '#333', mr: 1 }} />
                                                                <SoftTypography variant="h6" style={{color: '#333'}}>
                                                                    Talking to {summary.id}
                                                                </SoftTypography>
                                                            </SoftBox>
                                                            <SoftButton color="dark" size="inherit" variant="outlined" onClick={() => (handleCloseTalkTemplates(uniqueKey))} > 
                                                                <CloseIcon />
                                                            </SoftButton>
                                                        </SoftBox>
                                                        <div>
                                                            <SpeechToText 
                                                                promptType={uniqueKey}
                                                                onTextChange={(uniqueKey, text) => handleTextChange(uniqueKey, text)}
                                                                onRecordingStatusChange={handleRecordingStatusChange}                                                                          
                                                            />
                                                        </div>
                                                        {isRecordingToTemplates[uniqueKey] && (
                                                            <SoftBox pt={2} mb={-1} display="flex" alignItems="center" justifyContent="center" > 
                                                                <ScaleLoader speedMultiplier={0.8} height={15} width={3} color="#344767" /> 
                                                            </SoftBox>
                                                        )}
                                                        <SoftBox pt={3} display="flex" alignItems="center" justifyContent="center">
                                                            <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : isRecordingToTemplates[uniqueKey] ? "Stop recording to refine note" : ""} placement="right">
                                                                <span>
                                                                    <SoftButton disabled={!!isRecordingToTemplates[uniqueKey] || currentUserSubscription === "Silver Subscription"} onClick={() => currentUserSubscription !== "Silver Subscription" ? onRefineTemplate(templateName, summary, uniqueKey) : null} color="dark" variant="contained" startIcon={<AutoAwesomeOutlinedIcon sx={{ mr: 1 }}/>}>
                                                                        Re-Fine Note 
                                                                    </SoftButton>
                                                                </span>
                                                            </Tooltip>
                                                        </SoftBox>
                                                        {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                                                            <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                                            <SoftBadge
                                                                variant="contained"
                                                                color="error"
                                                                size="md"
                                                                badgeContent={
                                                                    <SoftTypography variant="button">
                                                                        🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                                                    </SoftTypography>
                                                                }
                                                                container
                                                            />
                                                            </SoftBox>
                                                        )}
                                                    </SoftBox>
                                                )}
                                              </Card>
                                          </SoftBox>
                                        );
                                      })
                                  ) : (
                                      <SoftBox textAlign="center" p={2}>
                                          <SoftTypography variant="body2">
                                              No summaries available for this template.
                                          </SoftTypography>
                                      </SoftBox>
                                  )}
                              {/*</Card>*/}
                          </SoftBox>
                      ))
                  ) : (
                      <Card sx={{ marginBottom: '20px', padding: '16px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                          <SoftBox textAlign="center" p={2}>
                              <SoftTypography variant="body2">
                                  No templates generated for this visit.
                              </SoftTypography>
                          </SoftBox>
                      </Card>
                  )}
              </SoftBox>
          )}

          {currentTab === 2 && (
            // Render Transcript
            <SoftBox sx={{ padding: '30px', maxHeight: '600px', overflowY: 'auto' }}>
              <Card sx={{ marginBottom: '20px', padding: '16px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                {renderTranscriptWithSpeakers(visitState.data.transcript, searchTerm)}
                  
              </Card>
            </SoftBox>
          )}

          { currentTab === 3 && (
            <SoftBox sx={{ padding: '20px', maxHeight: '600px', overflowY: 'auto' }} > 
              <SoftBox mt={2} mb={1} display="flex" alignItems="center" justifyContent="flex-start">
                  <SoftBadge
                      variant="contained"
                      color="warning"
                      size="md"
                      badgeContent={
                          <SoftTypography variant="h6">
                              Securely send one of the generated emails to the patient
                          </SoftTypography>
                      }
                  />
              </SoftBox>
              <SoftBox mt={1} mb={5} display="flex" flexDirection="column"  justifyContent="flex-start">
                  <SoftTypography ml={1.5} mr={3} variant="body2" >
                      This email will be send via our custom, white-labeled and HIPAA compliant service. 
                  </SoftTypography>
                  <SoftTypography ml={1.5} mr={3} variant="body2" >
                      The patient&apos;s email is deleted immediatly after the email has been send.
                  </SoftTypography>
              </SoftBox>
              {visitState.data.emails && Object.keys(visitState.data.emails).length > 0 ? (
                Object.entries(visitState.data.emails).map(([emailTitle, emailContent]) => (
                  <SoftBox key={emailTitle} p={2}>
                    <SoftBadge
                        variant="contained"
                        color="secondary"
                        size="md"
                        sx={{ ml:3, mb: -0.5}}
                        badgeContent={
                            <SoftTypography variant="h6" fontWeight="medium">
                                {emailTitle}
                            </SoftTypography>
                        }
                    />
                    <Card sx={{ marginBottom: '20px', padding: '16px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                      <SoftBox p={2} display="flex" flexDirection="column" justifyContent="flex-start" >
                          <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Email subject</SoftTypography>
                          <SoftInput
                              placeholder="Follow-up steps for [Patient Name]"
                              fullWidth
                              
                              value={emailSubjects[emailTitle] || ""}
                              onChange={(e) => handleEmailSubjectChange(emailTitle, e.target.value)}
                          />
                          <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Email content</SoftTypography>
                          <SoftInput
                              placeholder="generated email content specific to this session"
                              fullWidth
                              multiline
                              rows={10}
                              
                              value={emailContent.response}
                              onChange={(e) => handleEmailContentEdit(emailTitle, e.target.value)}
                          />
                          <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender name</SoftTypography>
                          { !senderName && (
                              <SoftBadge sx={{ mt: -0.5, mb:1, ml:0.5 }} size="xs" variant="contained" color="warning" badgeContent="TIP: You can configure a default sender name in your Patient Instructions tab in the recording page for future use." container  />
                          )}
                          <SoftInput
                              placeholder="your_email@example.com"
                              fullWidth
                              value={emailSenderNames[emailTitle] || senderName}
                              onChange={(e) => handleEmailSenderNameChange(emailTitle, e.target.value)}
                          />
                          <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender email</SoftTypography>
                            { !senderEmail && (
                                <SoftBadge sx={{ mt: -0.5, mb:1, ml:0.5 }} size="xs" variant="contained" color="warning" badgeContent="TIP: You can configure a default sender email in your Patient Instructions tab in the recording page for future use." container />
                            )}
                            <SoftInput
                                placeholder="your_email@example.com"
                                fullWidth
                                value={emailSenderEmails[emailTitle] || senderEmail}
                                onChange={(e) => handleEmailSenderEmailChange(emailTitle, e.target.value)}
                            />
                          <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Patient&apos;s email</SoftTypography>
                          <SoftInput
                              placeholder="email of the patient to send it to"
                              fullWidth
                              value={patientEmail}
                              onChange={handlePatientEmailChange}
                          />

                          <SoftBox display="flex" alignItems="center" mt={3}>
                              <Checkbox checked={agreementEmail} onChange={handleSetAgreement} />
                              <SoftTypography
                                  variant="button"
                                  fontWeight="regular"
                                  onClick={handleSetAgreement}
                                  sx={{ cursor: "pointer", userSelect: "none" }}
                              >
                                  The patient has given their consent for the transmission of their personal health information via email.
                              </SoftTypography>
                          </SoftBox>
                      </SoftBox>
                      <SoftBox px={2} pb={2} pt={0} display="flex" alignItems="center" justifyContent="flex-end" >
                          <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Email sending to patients is available for Platinum and Gold Package subscribers only." : !agreementEmail ? "You must obtain the patient's consent before sending the email." : "Send Email"} placement="top">
                              <span>
                                  <SoftButton disabled={!agreementEmail || currentUserSubscription === "Silver Subscription"} startIcon={<SendOutlinedIcon />} variant={agreementEmail && currentUserSubscription !== "Silver Subscription" ? "contained" : "outlined"} color="dark" onClick={() => currentUserSubscription !== "Silver Subscription" ? handleSendEmail(emailTitle) : null} >
                                      Send to patient
                                  </SoftButton>
                              </span>
                          </Tooltip>
                      </SoftBox>
                      {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                          <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                          <SoftBadge
                              variant="contained"
                              color="error"
                              size="md"
                              badgeContent={
                                  <SoftTypography variant="button">
                                      🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                  </SoftTypography>
                              }
                              container
                          />
                          </SoftBox>
                      )}
                      
                    </Card>
                  </SoftBox>
                ))
              ) : (
                <SoftBox textAlign="center" p={2}>
                  <SoftTypography variant="body2">
                    No emails generated for this visit.
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
          )}
        </SoftBox>
      )}
      <SoftSnackbar
          //bgWhite="true"
          color={snackbar.color}
          icon={snackbar.icon}
          title={snackbar.title}
          content={snackbar.message}
          open={snackbar.show}
          close={hideSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      />
</Card>

  );
}

VisitDetails.propTypes = {
  visit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,       
    summary: PropTypes.string,    
    timestamp: PropTypes.string.isRequired,
    // Add more properties as needed
  }).isRequired,
  selectedPatient: PropTypes.string,
  currentUserSubscription: PropTypes.string,
};


function PatientActionCell({ row, onPreview, onDelete }) {
  return (
    <div style={{ textAlign: 'right' }}>
      <ActionCell onPreview={() => onPreview(row.original.name)} onDelete={() => onDelete(row.original.name)} />
    </div>
  );
}

PatientActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onPreview: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

function PatientDataTable() {
  const [patients, setPatients] = useState([]);
  const [userId, setUserId] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientVisits, setPatientVisits] = useState([]);
  const visitsRef = useRef(null);
  const shouldScrollRef = useRef(false);
  const [isError, setIsError] = useState(false);
  const [isErrorInVisits, setIsErrorInVisits] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUserSubscription, setCurrentUserSubscription] = useState(null);


  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
    if (user) {
        const fetchUserSubscription = async () => {
            try {
                const db = getFirestore();
                const userSubDoc = collection(db, 'customerDetails', user.uid, 'subscriptions'); 
                const q = query(userSubDoc, where("status", "in", ["active", "trialing"]));
                const querySnapshot = await getDocs(q);
                let latestSubscription = null;

                querySnapshot.forEach((doc) => {
                if (!latestSubscription || doc.data().current_period_start.seconds > latestSubscription.current_period_start.seconds) {
                    latestSubscription = doc.data();
                }
                });

                setCurrentUserSubscription(latestSubscription.items[0].price.product.name);
                console.log("user subscription: ", latestSubscription.items[0].price.product.name);
            } catch (error) {
                console.error("Error fetching user subscription:", error);
                setCurrentUserSubscription(null);
            }   
        };
        fetchUserSubscription();
    }
    });
  }, []);
  

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const db = getFirestore();

  const summariesOrder = [
    "Chief Complaint",
    "Subjective",
    "Objective",
    "Risk Assessment",
    "Mental Status Exam",
    "Therapeutic Interventions",
    "Medications",
    "Family & Social history",
    "Assessment and Plan"
  ];

  function sortSummariesWithCustomOrder(generatedSummaries, fixedOrder) {
    if (!generatedSummaries) {
      console.error('generatedSummaries is undefined or null');
      return {};
    }
    // Separate predefined and custom summaries
    const predefinedSummaries = {};
    const customSummaries = {};

    Object.keys(generatedSummaries).forEach(key => {
        if (fixedOrder.includes(key)) {
            predefinedSummaries[key] = generatedSummaries[key];
        } else {
            customSummaries[key] = generatedSummaries[key];
        }
    });

    // Sort predefined summaries according to the fixed order
    const orderedSummaries = {};
    fixedOrder.forEach(key => {
        if (predefinedSummaries[key]) {
            orderedSummaries[key] = predefinedSummaries[key];
        }
    });

    // Append custom summaries below predefined ones
    // Optionally, sort customSummaries here based on another criterion if desired
    Object.keys(customSummaries).forEach(key => {
        orderedSummaries[key] = customSummaries[key];
    });

    return orderedSummaries;
  }

  const fetchPatientData = async (uid) => {
    setIsError(false);
    try {
      const userDocRef = doc(getFirestore(), "users", uid);
      const querySnapshot = await getDocs(collection(userDocRef, "summaries"));

      const patientData = querySnapshot.docs.map((doc) => ({
        name: doc.id,
        lastVisit: doc.data().lastVisit,
        age: doc.data().age,
        gender: doc.data().gender,
      }));

      const sortedPatients = patientData.sort((a, b) => new Date(b.lastVisit) - new Date(a.lastVisit));
      setPatients(sortedPatients);
    } catch (error) {
      console.error("Error fetching patient data:", error);
      setIsError(true);
    }
  };

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        fetchPatientData(user.uid); 
      }
    });

    return () => unsubscribe();
  }, []);


  const handlePreview = async (patientId) => {
    setSelectedPatient(patientId);
    shouldScrollRef.current = true;

    const visitQuery = query(collection(db, `users/${userId}/summaries/${patientId}/visits`));
    let errorCount = 0;

    try {
        const querySnapshot = await getDocs(visitQuery);
        const visits = await Promise.all(querySnapshot.docs.map(async (doc) => {
          try {
            const visitData = doc.data();
            const templatesSnapshot = await getDocs(collection(db, `users/${userId}/summaries/${patientId}/visits/${doc.id}/templates`));
            const templates = {};

            for (const templateDoc of templatesSnapshot.docs) {
                const templateName = templateDoc.id;
                const templateData = templateDoc.data();

                // Check if the 'templateSummaries' field exists and map its content
                if (templateData.templateSummaries) {
                  const sortedTemplateSummaries = sortSummariesWithCustomOrder(templateData.templateSummaries, summariesOrder);
                    templates[templateName] = Object.entries(sortedTemplateSummaries).map(([summaryId, summaryData]) => ({
                        id: summaryId,
                        data: summaryData
                    }));
                } else {
                    templates[templateName] = []; // Assign an empty array if no summaries
                }
            }

            return { id: doc.id, data: { ...visitData, templates: templates } };
          } catch (error) {
            console.error("error fetching visit data", error);
            errorCount++;
          }
        }));


        const sortedVisits = visits.filter(visit => visit !== undefined).sort((a, b) => {
          const dateA = new Date(a.data.timestamp);
          const dateB = new Date(b.data.timestamp);
          return dateB - dateA; // For descending order
        });

        setPatientVisits(sortedVisits);
        setIsErrorInVisits(errorCount);
    } catch (error) {
        console.error("Error fetching visits data: ", error);
    }
  };

  useEffect(() => {
    if (patientVisits.length > 0 && shouldScrollRef.current && visitsRef.current) {
      visitsRef.current.scrollIntoView({ behavior: "smooth" });
      shouldScrollRef.current = false; // Reset the ref after scrolling
    }
  }, [patientVisits]);

  const handleDeletePatient = async (patientId) => {
    setSelectedPatient(patientId);

    const patientDocRef = doc(db, `users/${userId}/summaries/${patientId}`);
    console.log("Deleting patient:", patientId);

    try {
      await deleteDoc(patientDocRef);
      console.log("Patient deleted successfully:", patientId);
      // Remove the patient from the state or re-fetch the patient list
      setPatients(prevPatients => prevPatients.filter(patient => patient.name !== patientId));
    } catch (error) {
      console.error("Error deleting patient:", error);
      // Handle any errors, such as showing an error message to the user
    }
  };

  const dataTableData = {
    columns: [
      { Header: "Patient Name", accessor: "name", width: "30%" },
      { Header: "Age", accessor: "age", width: "10%"},
      { Header: "Gender", accessor: "gender", width: "10%"},
      { Header: "Last Visit", accessor: "lastVisit", width: "30%" },
      { 
        Header: () => <div style={{ textAlign: 'left' }}>Action</div>,
        accessor: "action", 
        Cell: ({ row }) => ( <PatientActionCell row={row} onPreview={handlePreview} onDelete={handleDeletePatient} />),  // eslint-disable-line react/prop-types
        width: '10%'
      },
    ],
    rows: patients,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar staticNavbar={true} />
      <SoftBox pt={6} pb={3}>

        {/*{latestVisits.length > 0 && (
          <Card sx={{ mb: 4}}>
            <SoftBox p={3} lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Latest Patient Visits
              </SoftTypography>
            </SoftBox>
            <DataTable table={latestVisitsTableData} canSearch={false} /> 
          </Card>
        )}*/}

        { isError && (
          <SoftBox display='flex' flexDirection="column" justifyContent="center" alignItems="center" mb={3} >
            <SoftBadge
              variant="contained"
              color="error"
              size="md"
              sx={{ mb: 2}}
              badgeContent={
                <SoftTypography variant="h6" fontWeight="medium" >
                  There was an error while fetching the patient data, please check your internet connection and try again.
                </SoftTypography>
              }
              container
            />
            <SoftButton startIcon={<ReplayOutlinedIcon />}  variant="outlined" color="dark" onClick={fetchPatientData} >
              Try again
            </SoftButton>
          </SoftBox>
        )}
        <Card>
          <SoftBox p={3} lineHeight={1}>
            <SoftTypography variant="h5" fontWeight="medium">
              Patient Management Table
            </SoftTypography>
          </SoftBox>
          <DataTable table={dataTableData} canSearch />
        </Card>
        {patientVisits.length > 0 && (
          <SoftBox pt={3} ref={visitsRef}>
            <SoftBox display='flex' justifyContent="center" alignItems="center" py={2} mb={3} >

              <SoftBadge
                  variant="contained"
                  color={isErrorInVisits > 0 ? "error" : "success" }
                  size="md"
                  badgeContent={
                    <SoftTypography variant="h6" fontWeight="medium" >
                      Visits for {selectedPatient}
                    </SoftTypography>
                  }
                  //circular
                  container
              />
              {
                isErrorInVisits > 0 ? (
                  <Tooltip title={`We had problems with loading ${isErrorInVisits} visits`} placement="right" sx={{ marginLeft: 2 }}>
                    <SoftButton variant="outlined" color="warning" size="mdeium" circular iconOnly>
                      <Icon>error_outline</Icon>
                    </SoftButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="All visits loaded succesfully" placement="right" sx={{ marginLeft: 2}}>
                    <SoftButton variant="outlined" color="success" size="medium" circular iconOnly>
                      <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                    </SoftButton>
                  </Tooltip>
                )
              }
            </SoftBox >
            { isErrorInVisits > 0 && (
              <SoftBox mt={-2} pb={4} display='flex' flexDirection="column" justifyContent="center" alignItems="center" >
                <SoftTypography variant="h6" fontWeight="medium" >
                  We had problems with loading {isErrorInVisits} of the visits for {selectedPatient}. Please try again or report this problem of this keeps appearing. 
                </SoftTypography>
               
                <SoftButton sx={{ mt:2 }} startIcon={<ReplayOutlinedIcon />}  variant="outlined" color="dark" onClick={() => handlePreview(selectedPatient)} >
                  Try again 
                </SoftButton>

                <SoftTypography onClick={handleOpenModal} sx={{ mt:2, textDecoration: 'underline', cursor: 'pointer' }} variant="button" >
                  Report this problem.
                </SoftTypography>
                <ReportProblemModal open={isModalOpen} onClose={handleCloseModal} />


              </SoftBox>
            )}
            {patientVisits.map((visit, index) => (
              <SoftBox mb={2} key={index} display="flex" justifyContent="center" width="100%">
                <SoftBox width={{ xl: "100%", xxl: '90%'}} >
                  <VisitDetails visit={visit} selectedPatient={selectedPatient} currentUserSubscription={currentUserSubscription} />
                </SoftBox>
            </SoftBox>
            ))}
          </SoftBox>
        )}
      </SoftBox>
      {!userId && (
        < NotLoggedIn />
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default PatientDataTable;
